import React from 'react';
import { observer } from 'mobx-react';
import GroupsComponent from './Groups.component';
import useGroups from './useGroups';

const Container = () => {
    const {
        groups,
        devices,
        lang,
        telemetry,
        map,
        user,
        app,
        sidebar,
        state,
        handlers,
    } = useGroups();

    return (
        <>
            <GroupsComponent
                addDialogOpen={state.addDialogOpen}
                tab={sidebar.tab}
                page={app.page}
                addGroupVisible={state.addGroupVisible}
                devices={devices.deviceList}
                groups={groups.groupsList}
                loading={groups.loading || devices.loading}
                visibleList={state.visibleList}
                selectedGroupId={map.selectedGroupId}
                selectedGroupDevices={map.selectedGroupDevices}
                editedDeviceImei={devices.editedDeviceImei}
                infoDeviceImei={devices.infoDeviceImei}
                selectedDevices={map.selectedDevices}
                selectedDevice={map.selectedDevice}
                addDeviceToGroupVisible={state.addDeviceToGroupVisible}
                groupSettingsVisible={state.groupSettingsVisible}
                groupDeleteVisible={state.groupDeleteVisible}
                deviceDeleteVisible={state.deviceDeleteVisible}
                deviceBtnHover={state.deviceBtnHover}
                filter={state.filter}
                userType={user.type}
                dateFilter={map.dateFilter}
                fromDateFilter={map.fromDateFilter}
                toDateFilter={map.toDateFilter}
                settingDeviceImei={devices.settingDeviceImei}
                lang={lang.lang}
                columnVisibilityModel={telemetry.columnVisibilityModel}
                zoom={map.zoom}
                sortModel={telemetry.sortModel}
                settingsList={devices.settingsList}
                speedDialHover={state.speedDialHover}
                onGroupClick={handlers.handleGroupClick}
                onGroupSelect={handlers.handleGroupSelect}
                onGroupAddDeviceOpen={handlers.handleGroupAddDeviceOpen}
                onGroupAddDeviceClose={handlers.handleGroupAddDeviceClose}
                onGroupSettingsOpen={handlers.handleGroupSettingsOpen}
                onGroupSettingsClose={handlers.handleGroupSettingsClose}
                onDeviceSelect={handlers.handleDeviceSelect}
                onDeviceClick={handlers.handleDeviceClick}
                onAddGroupOpen={handlers.handleAddGroupOpen}
                onAddGroupClose={handlers.handleAddGroupClose}
                onAddDeviceOpen={handlers.handleAddDeviceOpen}
                onGroupDeleteOpen={handlers.handleGroupDeleteOpen}
                onGroupDeleteClose={handlers.handleGroupDeleteClose}
                onDeviceDeleteOpen={handlers.handleDeviceDeleteOpen}
                onDeviceDeleteClose={handlers.handleDeviceDeleteClose}
                onDeviceDescriptionOpen={handlers.handleDeviceDescriptionOpen}
                onDeviceTelemetryOpen={handlers.handleDeviceTelemetryOpen}
                onDeviceBtnHoverStart={handlers.handleDeviceBtnHoverStart}
                onDeviceBtnHoverStop={handlers.handleDeviceBtnHoverStop}
                onSearchChange={handlers.handleSearchChange}
                onAddDialog={handlers.handleAddDialog}
                onAddDiologClose={handlers.handleAddDiologClose}
                onDeviceSettingsOpen={handlers.handleDeviceSettingsOpen}
                onAddDeviceInDbOpen={handlers.handleAddDeviceInDbOpen}
                onDeviceInfoOpen={handlers.handleDeviceInfoOpen}
                onSpeedDialHoverStart={handlers.handleSpeedDialHoverStart}
                onSpeedDialHoverStop={handlers.handleSpeedDialHoverStop}
            />
        </>
    );
};

const GroupsContainer = observer(Container);

export default GroupsContainer;
